export default {
  deletionMessage: {
    id: 'bo_seller_profile_page_epr_deletion_modal_message',
    defaultMessage:
      'Are you sure you want to delete this number? Just know you’ll be able to add a new one at any time.',
  },
  modalTitle: {
    id: 'bo_seller_profile_page_epr_deletion_modal_title',
    defaultMessage: 'Delete EPR number',
  },
  cancelDelete: {
    id: 'bo_seller_profile_page_epr_deletion_modal_confirm',
    defaultMessage: 'No, keep it',
  },
  confirmDelete: {
    id: 'bo_seller_profile_page_epr_deletion_modal_cancel',
    defaultMessage: 'Yes, delete number',
  },
  eprInformationDeleteErrorTitle: {
    id: 'bo_seller_profile_page_epr_block_delete_error_title',
    defaultMessage: 'Oops!',
  },
  eprInformationDeleteErrorMessage: {
    id: 'bo_seller_profile_page_epr_block_delete_error_message',
    defaultMessage: 'Something went wrong while deleting an EPR category.',
  },
  eprInformationDeleteSuccessTitle: {
    id: 'bo_seller_profile_page_epr_block_delete_success_title',
    defaultMessage: 'Perfect!',
  },
  eprInformationDeleteSuccessMessage: {
    id: 'bo_seller_profile_page_epr_block_delete_success_message',
    defaultMessage: 'EPR detail has been correctly deleted',
  },
}
